import { UPDATE_PAGE_HEADER } from "../Actions/PageHeaderAction";


const InitialState = {
    header: '',
};

export const UpdatePageHeaderReducer = (state = InitialState, action: any) => {
    switch (action.type) {
        case UPDATE_PAGE_HEADER:
            return {
                ...state,
                header: action.payload,
            };

        default:
            return state;
    }
};
